import { useEffect, useState } from 'react'
import * as S from './styles'

export interface ModalButtonSettings {
  id?: string
  text: string
  callback: () => void
  sizeClass?: string
  colorClass?: string
  extraClasses?: string
  ariaLabel?: string
}

export interface ModalButtonProps {
  settings: ModalButtonSettings
}

const ModalButton = ({ settings }: ModalButtonProps) => {
  const [buttonClass, setButtonClass] = useState('')

  useEffect(() => {
    let name = 'btn'

    name += settings.sizeClass ? ` ${settings.sizeClass}` : ` md`
    name += settings.colorClass ? ` ${settings.colorClass}` : ` blue`

    if (settings.extraClasses) {
      name += ` ${settings.extraClasses}`
    }

    setButtonClass(name)
  }, [settings])

  return (
    settings && (
      <S.ModalButtonContainer
        id={settings.id}
        className={buttonClass}
        onClick={settings.callback}
        type="button"
        aria-label={settings.ariaLabel}
      >
        {settings.text}
      </S.ModalButtonContainer>
    )
  )
}

export default ModalButton
